import React from 'react';
import { BorderedButton } from '../../../../commonComponents/BorderedButton/BorderedButton';
import { RedButton } from '../../../../commonComponents/RedButton/RedButton';
import { PopupWrapper } from '../../../../commonComponents/PopupWrapper/PopupWrapper';
import styles from './index.module.sass';
import { ClosePopupButton } from '../../../../commonComponents/ClosePopupButton/ClosePopupButton';

export function DoneWarning({ handleSubmit, onClose, data }) {
  const handleClosePopupButtonClick = () => {
    onClose(null);
  };

  const submitForm = () => {
    handleSubmit(data, {
      onSettled: () => handleClosePopupButtonClick(),
    });
  };

  return (
    <>
      <PopupWrapper />
      <section className={styles.create_form}>
        <ClosePopupButton handleClosePopupButtonClick={handleClosePopupButtonClick} />
        <h2 className={styles.create_form__title}>
          <b>Caution!</b>
        </h2>
        <div className={styles.flex_container}>
          <form className={styles.form}>
            <label className={styles.form__label}>
              <span>
                By clicking <b>Done</b>, you confirm that you have completed all the videos in the
                folder or the specific videos assigned by your coach.
              </span>
            </label>
            <br />
            <div className={styles.buttons}>
              <BorderedButton
                handleButtonClick={handleClosePopupButtonClick}
                width={'20rem'}
              ></BorderedButton>
              <RedButton handleButtonClick={submitForm} title={`Done`} width={'20rem'}></RedButton>
            </div>
          </form>
        </div>
      </section>
    </>
  );
}
